import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { formatDisplayDateHuman, formatMoney } from '../../../../utils/func';
import {
  CategoryContainer,
  ContentBox,
  ContentBoxInfoRowContainer,
  ChargesBoxInfoRow,
  ContentBoxInlineLabel,
  ContentBoxInlineValue,
  ChargesResumeLine,
} from './css';

const RatesSummary = ({
  formData, description, billingAccounts, quoteApproved, createQuoteData,
  selectedQuote,
}) => {
  const protectedAccount = billingAccounts && billingAccounts.some((a) => a.accountNumber === formData.billTo && a.protected);

  return (
    <CategoryContainer>
      <ContentBox>
        <ContentBoxInfoRowContainer alignItems="flex-start">

          <ChargesBoxInfoRow>
            <p className="mb-4">
              <ContentBoxInlineLabel className="mr-2">{t('Service Level')}</ContentBoxInlineLabel>
              <ContentBoxInlineValue>{description}</ContentBoxInlineValue>
            </p>
            <p className="mb-4">
              <ContentBoxInlineLabel className="mr-2">{t('Expected Delivery Date')}</ContentBoxInlineLabel>
              <ContentBoxInlineValue>{formatDisplayDateHuman(createQuoteData && createQuoteData.estimatedDeliveryDate)}</ContentBoxInlineValue>
            </p>
          </ChargesBoxInfoRow>
          <ChargesBoxInfoRow>
            {
              (
                (selectedQuote && selectedQuote.isApproved === false)
                || (selectedQuote && selectedQuote.totalCharges && selectedQuote.totalCharges.value === 0)
                || (createQuoteData && createQuoteData.isApproved === false)
                || (createQuoteData && createQuoteData.totalCharges && createQuoteData.totalCharges.value === 0)
              )
                ? (<ContentBoxInlineValue>{t('CreateQuoteNotApprovedSummary')}</ContentBoxInlineValue>)
                : (
                  ((selectedQuote
                    && selectedQuote.isApproved === true
                    && selectedQuote.totalCharges
                    && selectedQuote.totalCharges.value > 0)
                  || (createQuoteData
                    && createQuoteData.totalCharges
                    && createQuoteData.totalCharges.value > 0))
                  && createQuoteData
                ) && (
                  <>
                    {createQuoteData.totalCharges && createQuoteData.totalCharges.value > 0 && quoteApproved
                      && (
                        <ChargesResumeLine>
                          <ContentBoxInlineValue>{t('TotalCharges')}</ContentBoxInlineValue>
                          <ContentBoxInlineValue>{formatMoney(createQuoteData.totalCharges.value, protectedAccount)}</ContentBoxInlineValue>
                        </ChargesResumeLine>
                      )}
                    {createQuoteData.charges && createQuoteData.charges.map((charge, index) => (
                      charge.amount.value > 0
                      && (
                        <ChargesResumeLine key={index}>
                          <ContentBoxInlineValue className="capitalize">
                            {charge && charge.description && charge.description.toLowerCase()}
                          </ContentBoxInlineValue>
                          <ContentBoxInlineValue>{formatMoney(charge.amount.value, protectedAccount)}</ContentBoxInlineValue>
                        </ChargesResumeLine>
                      )
                    ))}
                    {createQuoteData.tax && createQuoteData.tax.value > 0
                      && (
                        <ChargesResumeLine>
                          <ContentBoxInlineValue>{t('Tax')}</ContentBoxInlineValue>
                          <ContentBoxInlineValue>{formatMoney(createQuoteData.tax.value, protectedAccount)}</ContentBoxInlineValue>
                        </ChargesResumeLine>
                      )}

                    {(createQuoteData.totalAmount && createQuoteData.totalAmount.value === 0)
                      ? (
                        <ChargesResumeLine>
                          <ContentBoxInlineValue>{t('CreateQuoteNotApprovedSummary')}</ContentBoxInlineValue>
                        </ChargesResumeLine>
                      )
                      : (
                        <ChargesResumeLine withBorder>
                          <ContentBoxInlineLabel>{t('TotalPrice')}</ContentBoxInlineLabel>
                          <ContentBoxInlineLabel>
                            {createQuoteData.totalAmount && formatMoney(createQuoteData.totalAmount.value, protectedAccount)}
                            {' '}
                            {createQuoteData.totalAmount && createQuoteData.totalAmount.currencyCode}
                          </ContentBoxInlineLabel>
                        </ChargesResumeLine>
                      )}
                  </>
                )
            }
          </ChargesBoxInfoRow>

        </ContentBoxInfoRowContainer>
      </ContentBox>
    </CategoryContainer>
  );
};

RatesSummary.propTypes = {
  formData: PropTypes.object,
  selectedQuote: PropTypes.shape({
    expectedDeliveryDate: PropTypes.instanceOf(Date),
    isApproved: PropTypes.bool,
    totalCharges: PropTypes.shape({
      value: PropTypes.number,
    }),
    charges: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string,
        amount: PropTypes.shape({
          value: PropTypes.number,
        }),
      }),
    ),
    tax: PropTypes.shape({
      value: PropTypes.number,
    }),
    totalAmount: PropTypes.shape({
      value: PropTypes.number,
    }),
  }),
  description: PropTypes.string,
  quoteApproved: PropTypes.bool,
  billingAccounts: PropTypes.arrayOf(
    PropTypes.shape({
      accountNumber: PropTypes.string,
      protected: PropTypes.bool,
    }),
  ),
  createQuoteData: PropTypes.object,
};

export default RatesSummary;
